module.exports = __webpack_public_path__ + "img/case4.569862fa.svg";